import { FC, useMemo } from "react";
import { getTargetMultipleOpportunitiesGridColumns } from "./targetMultipleOpportunitiesGridColumns";
import { TaskTargetDataGrid } from "../../common/TaskTargetDataGrid";
import { useAppSelector } from "@/store/hooks";
import { taskManagementTargetOpportunitiesSelector } from "@/store/task-management/selectors/form/target/opportunities/taskManagementTargetOpportunitiesSelector";
import { isKubernetesOpportunityTarget } from "@/components/pages/common/task-management/utils/helpers/isKubernetesOpportunityTarget";

export const TargetMultipleOpportunities: FC = () => {
  const opportunities = useAppSelector(
    taskManagementTargetOpportunitiesSelector,
  );

  const isKubernetes = useMemo(
    () => !!opportunities?.some(isKubernetesOpportunityTarget),
    [opportunities],
  );

  const columnDefs = useMemo(() => {
    return getTargetMultipleOpportunitiesGridColumns(isKubernetes);
  }, [isKubernetes]);

  if (!opportunities) {
    return null;
  }

  return <TaskTargetDataGrid rowData={opportunities} columnDefs={columnDefs} />;
};
